/**
 * @ipc/validation · src/schemas/analytics-filters-form.ts — форма фильтров экрана
 * «Аналитика» admin-ui (раздел 11, `analyticsFilterSchema`/`breakdownQuerySchema`
 * backend, `apps/backend/src/domains/analytics/analytics.schemas.ts`). Клиентская
 * копия для react-hook-form + zodResolver: та же форма периода/измерений, но
 * `from`/`to` приходят из `<input type="date">` как `YYYY-MM-DD` — конвертация в
 * ISO с offset делает entities/analytics (mappers), не эта схема.
 *
 * status/provider — те же канонические enum'ы, что payments/merchants
 * (`paymentStatusSchema` / `paymentProviderSchema` из common/primitives).
 */
import { z } from 'zod/v4';
import { paymentProviderSchema, paymentStatusSchema } from '../common/primitives.ts';

export const analyticsPeriodPresetSchema = z.enum(['today', 'yesterday', 'last7d', 'last30d', 'mtd', 'custom']);
export type AnalyticsPeriodPreset = z.infer<typeof analyticsPeriodPresetSchema>;

/** Alias: провайдер-фильтр аналитики = канонический PaymentProvider. */
export const analyticsProviderFilterSchema = paymentProviderSchema;
export type AnalyticsProviderFilter = z.infer<typeof analyticsProviderFilterSchema>;

/** Alias: статус-фильтр аналитики = канонический PaymentStatus. */
export const analyticsStatusFilterSchema = paymentStatusSchema;
export type AnalyticsStatusFilter = z.infer<typeof analyticsStatusFilterSchema>;

export const analyticsBreakdownGroupBySchema = z.enum([
  'status',
  'provider',
  'merchant',
  'ps',
  'period',
  'mxik',
  'packageCode',
]);
export type AnalyticsBreakdownGroupBy = z.infer<typeof analyticsBreakdownGroupBySchema>;

/** Форма фильтров экрана: даты как YYYY-MM-DD (из `<input type="date">`) либо пусто. */
export const analyticsFiltersFormSchema = z.object({
  preset: analyticsPeriodPresetSchema.default('last30d'),
  from: z.string().optional(),
  to: z.string().optional(),
  merchantId: z.string().optional(),
  provider: analyticsProviderFilterSchema.optional(),
  status: analyticsStatusFilterSchema.optional(),
  /** ИКПУ (mxik) — exact match. */
  mxik: z.string().optional(),
  /** Код упаковки — exact match. */
  packageCode: z.string().optional(),
});
export type AnalyticsFiltersFormDto = z.infer<typeof analyticsFiltersFormSchema>;
